interface FontPage {
  imageUrl: string
  searchUrl: string
}

export const FONTS_PAGES: Record<string, FontPage> = {
  'christmas-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/ChristmasFonts.jpg',
    searchUrl:
      'https://www.creativefabrica.com/search/?query=Christmas&category=Script%2520%2526%2520Handwritten%2CSerif%2CDisplay%2CSans%2520Serif%2CSlab%2520Serif&type=Fonts',
  },
  'wedding-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/WeddingFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=wedding&type=Fonts',
  },
  'halloween-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/HalloweenFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=halloween&type=Fonts',
  },
  'tattoo-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/TattooFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=tattoo&type=Fonts',
  },
  'cricut-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/CricutFonts.jpg',
    searchUrl:
      'https://www.creativefabrica.com/search/?query=cricut&category=Script%2520%2526%2520Handwritten',
  },
  'retro-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/RetroFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=retro&type=Fonts',
  },
  'calligraphy-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/CalligraphyFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=calligraphy&type=Fonts',
  },
  'cursive-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/CursiveFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=cursive&type=Fonts',
  },
  'graffiti-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/GraffitiFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=grafitti&type=Fonts',
  },
  'handwriting-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/HandwritingFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=handwriting&type=Fonts',
  },
  'heart-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/HeartFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=heart&type=Fonts',
  },
  'bubble-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/BubbleFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=bubble&type=Fonts',
  },
  'typewriter-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/TypewriterFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=typewriter&type=Fonts',
  },
  'cute-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/CuteFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=cute&type=Fonts',
  },
  'cool-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/CoolFonts.jpg',
    searchUrl:
      'https://www.creativefabrica.com/search/?query=cool&category=Sans%2520Serif%2CDisplay%2CDecorative%2CSerif%2CColor%2520Fonts%2CDingbats%2CSlab%2520Serif%2CBlackletter&type=Fonts',
  },
  'fancy-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/FancyFonts.jpg',
    searchUrl:
      'https://www.creativefabrica.com/search/?query=fancy&category=Script%2520%2526%2520Handwritten&type=Fonts',
  },
  'aesthetic-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/AestheticFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=Aesthetic&type=Fonts',
  },
  'spooky-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/SpookyFonts.jpg',
    searchUrl:
      'https://www.creativefabrica.com/search/?query=spooky&category=Display%2CSerif%2CBlackletter%2CDecorative&type=Fonts',
  },
  'pixel-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/PixelFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=pixel&type=Fonts',
  },
  'western-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/WesternFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=western&type=Fonts',
  },
  'college-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/Collegefonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=college&type=Fonts',
  },
  'groovy-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/GroovyFonts.jpg',
    searchUrl:
      'https://www.creativefabrica.com/search/?query=groovy&category=Script%2520%2526%2520Handwritten%2CDisplay%2CColor%2520Fonts%2CSans%2520Serif%2CSerif%2CDingbats%2CSlab%2520Serif%2CBlackletter&type=Fonts',
  },
  'signature-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/SignatureFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=signature&type=Fonts',
  },
  'bold-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/BoldFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=bold&type=Fonts',
  },
  'death-metal-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/DeathMetalFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=death%20metal&type=Fonts',
  },
  'stencil-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/StencilFonts.jpg',
    searchUrl:
      'https://www.creativefabrica.com/search/?query=stencil&category=Display%2CSans%2520Serif%2CSerif%2CDecorative%2CBlackletter%2CSlab%2520Serif%2CColor%2520Fonts&type=Fonts',
  },
  'baseball-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/BaseballFonts.jpg',
    searchUrl:
      'https://www.creativefabrica.com/search/?query=baseball&category=Display%2CDecorative%2CColor%2520Fonts%2CSlab%2520Serif%2CSerif%2CDingbats%2CBlackletter%2CSans%2520Serif&type=Fonts',
  },
  'vintage-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/VintageFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=vintage&type=Fonts',
  },
  'modern-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/ModernFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=modern&category=Serif&type=Fonts',
  },
  'pretty-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/PrettyFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=pretty&type=Fonts',
  },
  'medieval-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/MedievalFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=medieval&type=Fonts',
  },
  '70s-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/70sFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=70s&type=Fonts',
  },
  'military-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/MilitaryFonts.jpg',
    searchUrl:
      'https://www.creativefabrica.com/search/?query=military&category=Display%2CSans%2520Serif%2CDecorative%2CSerif&type=Fonts',
  },
  'space-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/SpaceFonts.jpg',
    searchUrl:
      'https://www.creativefabrica.com/search/?query=space&category=Sans%2520Serif%2CDisplay%2CSlab%2520Serif%2CBlackletter&type=Fonts',
  },
  '80s-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/80sFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=80s&type=Fonts',
  },
  'pirate-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/PirateFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=pirate&type=Fonts',
  },
  'comic-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/ComicFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=comic&type=Fonts',
  },
  'block-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/BlockFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=block&type=Fonts',
  },
  'chicano-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/ChicanoFonts.jpg',
    searchUrl: 'https://www.creativefabrica.com/search/?query=Chicano&type=Fonts',
  },
  'manga-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/MangaFonts.jpg',
    searchUrl:
      'https://www.creativefabrica.com/search/?query=manga&category=Display%2CDecorative%2CSans%2520Serif%2CColor%2520Fonts&type=Fonts',
  },
  'elegant-fonts': {
    imageUrl: 'https://www.creativefabrica.com/wp-content/uploads/2025/10/07/ElegantFonts.jpg',
    searchUrl:
      'https://www.creativefabrica.com/search/?query=elegant&category=Serif%2CSans%2520Serif%2CSlab%2520Serif%2CBlackletter&type=Fonts',
  },
} as const
